export const detailCopy = {
  labels: {
    avgDuration: 'Avg. Duration',
    actions: 'Actions',
    branch: 'Branch',
    commitSha: 'Commit SHA',
    created: 'Created',
    defaultBranch: 'Default Branch',
    details: 'Details',
    duration: 'Duration',
    executionRun: 'Execution Run',
    finished: 'Finished',
    flakeScore: 'Flake Score',
    frequency: 'Frequency',
    job: 'Job',
    jobKey: 'Job Key',
    jobName: 'Job Name',
    jobStatus: 'Job Status',
    jobUrl: 'Job URL',
    lastUpdated: 'Last Updated',
    latestDuration: 'Latest Duration',
    latestRun: 'Latest Run',
    latestStatus: 'Latest Status',
    latestTimestamp: 'Latest Timestamp',
    metrics: 'Metrics',
    name: 'Name',
    output: 'Output',
    passRate: 'Success Rate',
    pipeline: 'Pipeline',
    pipelineKey: 'Pipeline Key',
    pipelineUrl: 'Pipeline URL',
    plannedFor: 'Planned For',
    project: 'Project',
    provider: 'Provider',
    release: 'Release',
    releasedAt: 'Released At',
    results: 'Results',
    resultsFile: 'Results File',
    run: 'Run',
    source: 'Source',
    stage: 'Stage',
    started: 'Started',
    status: 'Status',
    suite: 'Suite',
    suiteRun: 'Suite Run',
    suites: 'Suites',
    tags: 'Tags',
    test: 'Test',
    tests: 'Tests',
    timestamp: 'Timestamp',
    uploaded: 'Uploaded',
    uploadedBy: 'Uploaded by',
  },
} as const;

export type DetailLabelKey = keyof typeof detailCopy.labels;

export const getDetailLabel = (key: DetailLabelKey): string => detailCopy.labels[key];

export const getDetailCopySamples = (): string[] => Object.values(detailCopy.labels);
